export const DELIVERY_TEXTS = {
  SCREEN_TITLE: 'Entregas',
  ROUTE: 'Ruta',
  DEALER: 'Repartidor',
  SCHEDULED_HOUR: 'Programada',
  ARRIVED_AT: 'Llegó',
  DEALER_WAIT: 'Espera',
  WAIT_STATUS: 'Estado',
  LOADING: 'Cargando rutas...',
  EMPTY: 'No hay rutas para hoy',
  ERROR: 'No pudimos cargar las rutas. Intenta de nuevo.',
  NO_SCHEDULE: '-',
  EMPTY_CELL: '—'
}

export const CONNECTION_NOTICE_TEXTS = {
  CONNECTION_LOST: 'Sin conexión',
  LAST_UPDATE: 'última actualización',
  RETRYING: 'reintentando',
  SESSION_EXPIRED: 'Tu sesión expiró',
  GO_TO_LOGIN: 'Iniciar sesión'
}

export const HTTP_UNAUTHORIZED = 401

export const LOGIN_ROUTE_NAME = 'login'
